export default __webpack_public_path__ + "static/media/secondary.66bdc74656e3d751c598495e82d52156.svg";